import {
  Avatar,
  FlexCell,
  FlexRow,
  FlexSpacer,
  IconButton,
  Panel,
  Text,
} from '@epam/loveship'
import { ReactComponent as DeleteIcon } from '@epam/assets/icons/common/action-deletelight-18.svg'
import { ReactComponent as EditIcon } from '@epam/assets/icons/common/content-edit-18.svg'
import { EditReviewForm } from '../../../EditReviewForm/EditReviewForm'
import {
  LocationReviewResponse,
  PointReviewResponse,
  UserResponse,
} from '../../../../../../constants/types'
import css from './ReviewsList.module.scss'
import { RatingReadOnly } from '../../../../../../components/RatingReadOnly/RatingReadOnly'

type ReviewsListProps = {
  reviews: PointReviewResponse[] | LocationReviewResponse[] | undefined
  user: UserResponse | null
  deleteReview: (reviewId: number) => void
  refetchReviews: (itemId: number) => void
  refetchItems: (id: number) => void
  isToggle: any
  toggleEditReview: (id: number) => void
}

export const ReviewsList = ({
  reviews,
  user,
  deleteReview,
  refetchReviews,
  refetchItems,
  isToggle,
  toggleEditReview,
}: ReviewsListProps) => {
  const clickHandleEdit = (id: number): void => {
    toggleEditReview(id)
  }

  const authorIsAlwaysOnTop = (
    a: PointReviewResponse | LocationReviewResponse,
    b: PointReviewResponse | LocationReviewResponse
  ) => {
    if (a.creator.id === user?.id) {
      return -1
    }

    if (b.creator.id === user?.id) {
      return 1
    }
  }

  const sortByDate = (
    a: PointReviewResponse | LocationReviewResponse,
    b: PointReviewResponse | LocationReviewResponse
  ) => {
    return Date.parse(b.timestampUtc) - Date.parse(a.timestampUtc)
  }

  const sortedReviews =
    reviews && Array.isArray(reviews)
      ? [...reviews].sort((a, b) => {
          return authorIsAlwaysOnTop(a, b) || sortByDate(a, b)
        })
      : []

  return (
    <>
      {!reviews?.length && (
        <Text size="36" font="sans" color="night700">
          There is no reviews yet
        </Text>
      )}
      {!!reviews?.length &&
        sortedReviews.map((review) => {
          return (
            <Panel cx={css.reviewPanel} key={review.id}>
              <FlexRow
                alignItems="center"
                spacing="12"
                key={review.id}
                cx={css.reviewTitle}
              >
                <Avatar size="36" alt="avatar" img={review.creator.picture} />

                <FlexRow cx={css.reviewHeader}>
                  <Text
                    cx={css.text}
                    lineHeight="24"
                    fontSize="16"
                    color="night700"
                    font="sans-semibold"
                  >
                    {review.creator.name}
                  </Text>
                  <FlexSpacer />
                  {review.creator.id === user?.id && (
                    <FlexRow spacing="6">
                      <IconButton
                        icon={EditIcon}
                        onClick={() => clickHandleEdit(review.id)}
                        isDisabled={isToggle}
                      />
                      <IconButton
                        icon={DeleteIcon}
                        onClick={() => deleteReview(review.id)}
                      />
                    </FlexRow>
                  )}
                </FlexRow>
              </FlexRow>

              <FlexCell>
                <Text
                  cx={css.date}
                  lineHeight="18"
                  fontSize="12"
                  color="night600"
                >
                  {new Date(review.timestampUtc).toLocaleDateString()}
                </Text>
              </FlexCell>

              {isToggle !== review.id ? (
                <>
                  <FlexCell width="auto">
                    <RatingReadOnly value={review.rating} />
                  </FlexCell>

                  <FlexRow borderBottom>
                    <FlexCell width="100%">
                      <Text
                        size="36"
                        font="sans"
                        color="night700"
                        cx={css.text}
                      >
                        {review.reviewText}
                      </Text>
                    </FlexCell>
                  </FlexRow>
                </>
              ) : (
                user && (
                  <EditReviewForm
                    review={review}
                    toggleEditReview={toggleEditReview}
                    refetchReviews={refetchReviews}
                    refetchItems={refetchItems}
                  />
                )
              )}
            </Panel>
          )
        })}
    </>
  )
}
